export default {"src":"/_next/static/image/public/images/ic_bell_white_vertical_menu.03c9b41945dc77cd62eaec7becbae726.svg","height":20,"width":20};